import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CurrencyService {
  currency = signal<string>('EUR');

  constructor() {
    const saved = localStorage.getItem('currency') || 'EUR';
    this.setCurrency(saved);
  }

  setCurrency(code: string) {
    this.currency.set(code);
    localStorage.setItem('currency', code);
  }

  get currentCurrency() {
    return this.currency();
  }
}
